import {Box} from '@mui/material'
import './index.scss'

interface LabelAdderProps {
    label?: string
    id?: string
    input?: any
    showAsterik?: boolean
    helperText?: string
}

const LabelAdder = ({
    label,
    id,
    input,
    showAsterik,
    helperText
}: LabelAdderProps) => (
    <Box className='contact-input__container'>
        <label htmlFor={id}>
            {label}
            {showAsterik && <span>&#42;</span>}
        </label>
        {input}
        <span className='helper-text'>{helperText}</span>
    </Box>
)

LabelAdder.defaultProps = {
    showAsterik: false
}

export default LabelAdder
